module.exports = __webpack_public_path__ + "static/media/logo_text.f406a951.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo_text.svg
// module id = 925
// module chunks = 0